import { NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import {
  LayoutDashboard,
  Package,
  Tag,
  ClipboardList,
  Building2,
  LogOut,
} from "lucide-react";

const NavItem = ({ to, icon: Icon, label, end, testId }) => (
  <NavLink
    to={to}
    end={end}
    data-testid={testId}
    className={({ isActive }) =>
      `flex items-center gap-3 px-5 py-3 text-xs uppercase tracking-ultra font-bold transition-colors ${
        isActive ? "bg-white text-black" : "text-white/70 hover:text-white"
      }`
    }
  >
    <Icon className="w-4 h-4" /> {label}
  </NavLink>
);

export default function AdminLayout() {
  const { admin, checking, logout } = useAuth();
  const navigate = useNavigate();

  if (checking) return <div className="py-24 text-center text-sm">Loading...</div>;
  if (!admin) return <Navigate to="/admin" replace />;

  const handleLogout = () => {
    logout();
    navigate("/admin");
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid md:grid-cols-[240px_1fr]" data-testid="admin-layout">
      <aside className="bg-black text-white min-h-full">
        <div className="px-5 pt-8 pb-6">
          <div className="text-[10px] uppercase tracking-ultra text-white/50">Admin</div>
          <div className="mt-1 font-black text-xl tracking-tighter">Control</div>
          <div className="mt-1 text-[10px] text-white/50">{admin.email}</div>
        </div>
        <nav className="flex flex-col">
          <NavItem to="/admin/dashboard" end icon={LayoutDashboard} label="Dashboard" testId="admin-nav-dashboard" />
          <NavItem to="/admin/products" icon={Package} label="Products" testId="admin-nav-products" />
          <NavItem to="/admin/categories" icon={Tag} label="Categories" testId="admin-nav-categories" />
          <NavItem to="/admin/orders" icon={ClipboardList} label="Orders" testId="admin-nav-orders" />
          <NavItem to="/admin/business" icon={Building2} label="Business" testId="admin-nav-business" />
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 px-5 py-3 text-xs uppercase tracking-ultra font-bold text-white/70 hover:text-accent transition-colors text-left mt-8"
            data-testid="admin-logout"
          >
            <LogOut className="w-4 h-4" /> Log out
          </button>
        </nav>
      </aside>
      <main className="p-8 bg-[#f5f5f0]">
        <Outlet />
      </main>
    </div>
  );
}
